import React, { Component } from 'react'
import { Button, Checkbox, Input, Modal, Popconfirm, Select, Table } from 'antd'
import _ from 'lodash'

import './QSTableSelectImportModal.scss'

const { Search } = Input
const { Option } = Select

export default class QSTableSelectImportModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataset: [],
            filter: {},
            searchBarInput: '',
            selectedRowIdx: null,
            popconfirmVisible: false
        }

        this.handleRowClick = this.handleRowClick.bind(this)
        this.handleModalSubmit = this.handleModalSubmit.bind(this)
        this.handleSearchBarInputChange = this.handleSearchBarInputChange.bind(this)
        this.handleSearchBarSearch = this.handleSearchBarSearch.bind(this)
    }

    filterProject() {
        const { filter, searchBarInput } = this.state
        let newTemplateList = _.cloneDeep(this.props.listDataSource)
        let filterCondition = {}

        _.forEach(filter, (value, key) => {
            if (value && key !== 'size') {
                filterCondition[_.snakeCase(key)] = value
            }
        })

        newTemplateList = _.filter(newTemplateList, filterCondition)

        if (filter.size) {
            switch (filter.size) {
                case '<= 300':
                    newTemplateList = _.filter(newTemplateList, (project) => project.size <= 300)
                    break
                case '301 - 500':
                    newTemplateList = _.filter(newTemplateList, (project) => project.size > 300 && project.size <= 500)
                    break
                case '501 - 800':
                    newTemplateList = _.filter(newTemplateList, (project) => project.size > 500 && project.size <= 800)
                    break
                case '> 800':
                    newTemplateList = _.filter(newTemplateList, (project) => project.size > 800)
                    break
                default:
            }
        }

        newTemplateList = _.filter(newTemplateList, (template) => {
            return _.filter(_.map(_.values(template), (value) => value ? value.toString().toUpperCase() : ''), (value) => value.indexOf(searchBarInput.toUpperCase()) !== -1).length !== 0
        })

        this.setState({ dataset: newTemplateList })
    }

    handlePopconfirmVisibleChange(disabled, popconfirmVisible) {
        if (disabled) {
            this.setState({ popconfirmVisible: false })
        } else {
            this.setState({ popconfirmVisible })
        }
    }

    handleFilterChange(field, value) {
        let newFilter = _.cloneDeep(this.state.filter)
        newFilter[field] = value

        this.setState({ filter: newFilter })
    }

    handleSearchBarInputChange(e) {
        this.setState({ searchBarInput: e.target.value })
    }

    handleSearchBarSearch(value) {
        this.filterProject()
    }

    handleRowClick(record, idx) {
        this.setState({ selectedRowIdx: idx })
    }

    handleModalSubmit() {
        const { onConfirm } = this.props
        const { dataset, selectedRowIdx } = this.state

        onConfirm(dataset[selectedRowIdx]._id)
    }

    componentDidUpdate(prevProps, prevState) {
        const { listDataSource } = this.props
        const { filter } = this.state

        if (!_.isEqual(prevProps.listDataSource, listDataSource)) {
            this.setState({ dataset: listDataSource, selectedRowIdx: null })
        }

        if (!_.isEqual(prevProps.filter, this.props.filter)) {
            this.setState({ filter: this.props.filter })
        }

        if (!_.isEqual(prevState.filter, filter)) {
            this.filterProject()
            this.setState({ selectedRowIdx: null })
        }
    }

    render() {
        const { visible, onCancel, listParentColumns, infoText, importContent, importTAndC, onCheckboxChange, modalBtnText, popconfirmText, locationList, estateList } = this.props
        const { dataset, filter, searchBarInput, selectedRowIdx, popconfirmVisible } = this.state
        const { category, type, size, siteLocation, estateName } = filter

        return (
            <Modal
                width="60%"
                wrapClassName="QSTableSelectImportModal"
                visible={visible}
                footer={null}
                onCancel={onCancel}
            >
                <p className="label">{infoText}</p>
                <div className="filter">
                    <Select 
                        placeholder="Category" 
                        dropdownMatchSelectWidth={false} 
                        value={category}
                        onChange={this.handleFilterChange.bind(this, 'category')}
                        allowClear
                    >
                        <Option value="RE">RE</Option>
                        <Option value="OF">OF</Option>
                        <Option value="MI">MI</Option>
                    </Select>
                    <Select 
                        placeholder="Type" 
                        dropdownMatchSelectWidth={false} 
                        value={type}
                        onChange={this.handleFilterChange.bind(this, 'type')}
                        allowClear
                    >
                        <Option value="Apartment">Apartment</Option>
                        <Option value="House">House</Option>
                        <Option value="Subdivided Flat">Subdivided Flat</Option>
                        <Option value="Shop">Shop</Option>
                        <Option value="NGO">NGO</Option>
                        <Option value="Restaurant">Restaurant</Option>
                        <Option value="Elderly House">Elderly House</Option>
                        <Option value="School">School</Option>
                        <Option value="Office">Office</Option>
                    </Select>
                    <Select 
                        placeholder="Size" 
                        dropdownMatchSelectWidth={false} 
                        value={size}
                        onChange={this.handleFilterChange.bind(this, 'size')}
                        allowClear
                    >
                        <Option value="<= 300">&lt;= 300</Option>
                        <Option value="301 - 500">301 - 500</Option>
                        <Option value="501 - 800">501 - 800</Option>
                        <Option value="> 800">&gt; 800</Option>
                    </Select>
                    <Select 
                        placeholder="Location" 
                        dropdownMatchSelectWidth={false} 
                        value={siteLocation}
                        onChange={this.handleFilterChange.bind(this, 'siteLocation')}
                        allowClear
                    >
                        {
                            _.map(locationList, (location, i) => (
                                <Option key={location} value={location}>{location}</Option>
                            ))
                        }
                    </Select>
                    <Select 
                        placeholder="Estate" 
                        dropdownMatchSelectWidth={false} 
                        value={estateName}
                        onChange={this.handleFilterChange.bind(this, 'estateName')}
                        allowClear
                    >
                        {
                            _.map(estateList, (estate, i) => (
                                <Option key={estate} value={estate}>{estate}</Option>
                            ))
                        }
                    </Select>
                    <Search 
                        placeholder="Search Bar" 
                        value={searchBarInput}
                        onChange={this.handleSearchBarInputChange}
                        onSearch={this.handleSearchBarSearch}
                    />
                </div>
                <div className="document-list">
                    <Table 
                        className="document-table"
                        rowKey={'_id'}
                        columns={listParentColumns}
                        dataSource={dataset}
                        pagination={false}
                        size="middle"
                        scroll={{y: 250}}
                        onRowClick={this.handleRowClick}
                        rowClassName={(record, idx) => idx === selectedRowIdx ? 'selected' : ''}
                    />
                </div>
                {
                    (importContent !== undefined && importTAndC !== undefined) &&
                        <div className="checkbox-gp">
                            <Checkbox checked={importContent} onChange={() => onCheckboxChange('importContent')}>Content</Checkbox>
                            <Checkbox checked={importTAndC} onChange={() => onCheckboxChange('importTAndC')}>Terms And Conditions</Checkbox>
                        </div>
                }
                <div className="footer">
                    <Popconfirm
                        visible={popconfirmVisible}
                        placement="bottom"
                        title={popconfirmText}
                        onVisibleChange={this.handlePopconfirmVisibleChange.bind(this, (selectedRowIdx == null))}
                        onConfirm={this.handleModalSubmit}
                    >
                        <Button type="primary" size="large" disabled={selectedRowIdx == null}>{modalBtnText}</Button>
                    </Popconfirm>
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/QSTableSelectImportModal/QSTableSelectImportModal.js